import { render, staticRenderFns } from "./SalesRevenueDetailDialog.vue?vue&type=template&id=617968cb&scoped=true"
import script from "./SalesRevenueDetailDialog.vue?vue&type=script&lang=js"
export * from "./SalesRevenueDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./SalesRevenueDetailDialog.vue?vue&type=style&index=0&id=617968cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617968cb",
  null
  
)

export default component.exports